import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-12 md:py-16 bg-background-950">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-white mb-3">
          立即开始久久在线观看
        </h2>
        <p className="text-sm text-foreground-400 mb-8 max-w-lg mx-auto leading-relaxed">
          海量高清视频资源尽在久久在线观看，无需注册、无需下载，打开浏览器即可畅享极致观影体验
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/dianying"
            className="bg-primary-500 hover:bg-primary-600 text-white px-8 py-3 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            开始观看
          </Link>
          <Link
            to="/about"
            className="border border-background-600 hover:border-background-400 text-foreground-300 hover:text-white px-8 py-3 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}